export default "__VITE_ASSET__KkR_XZHi__"